import type { TranslateService } from '@ngx-translate/core';
import type { WebWidgetModel } from '@web/types';
import type { AccordionEntity } from '@sites/entity-core';

import { Widgets } from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';
import { createAccordion } from '@sites/entity-core';

import { AccordionControlComponent } from '@web/widgets/accordion/components/accordion-control/accordion-control.component';
import { AccordionViewComponent } from '@web/widgets/accordion/components/accordion-view/accordion-view.component';

// DEFAULT COMPONENT SETTINGS — sourced from the canonical entity factory in @sites/entity-core.
// The package owns the data shape but deliberately not i18n: the 3 seeded items' localised
// title/content HTML is passed in via `accordionList` overrides, mirroring button's `buttonOverrides`.
const accordionData = (translate: TranslateService): AccordionEntity['data'] => {
    const item = {
        title: `<h2>${translate.instant('text_element_header')}</h2>`,
        content: `<p>${translate.instant('text_element_text')}</p>`,
    };

    return createAccordion({ accordionList: [item, item, item] }).data;
};
// END DEFAULT SETTINGS

export const accordionWidgetModel: WebWidgetModel = {
    componentView: AccordionViewComponent,
    componentControl: AccordionControlComponent,
    name: Widgets.ACCORDION,
    label: 'widget_accordion_label',
    data: accordionData,
    permission: defaultWidgetPermission,
    params: defaultWidgetParams,
    signalForm: true,
};
